import { GlobalActionTypes } from '../actions'
import { TAction, IInitialState } from './actionType/actionType'

/*
  @Gowtham 
    - Reducer hook state-action template file 
*/
const reducer = (state: IInitialState, action: TAction) => {
  const { type, payload } = action

  switch (type) {
    case GlobalActionTypes.LOADING_TO_TRUE:
      /*
      @Gowtham 
        - Action to set loading to true to create spinner on the screen
      */
      return {
        ...state,
        loading: payload,
      }
    case GlobalActionTypes.LOADING_TO_FALSE:
      /*
      @Gowtham 
        - Action to set loading to false to remove spinner off the screen
      */
      return {
        ...state,
        loading: payload,
      }
    case GlobalActionTypes.SNACKBAR_UPDATE:
      /*
      @Gowtham 
        - Action to update snackbar states
      */
      return {
        ...state,
        snackbar: {
          message: payload.message,
          status: payload.status,
          type: payload.type,
        },
      }

    case GlobalActionTypes.ALERT_OPEN:
      /*
      @Gowtham 
        - Action to update snackbar appearance state
      */
      return {
        ...state,
        alertOpen: payload,
      }

    case GlobalActionTypes.ALERT_CLOSE:
      /*
      @Gowtham 
        - Action to update snackbar appearance state
      */
      return {
        ...state,
        alertOpen: payload,
      }

    default:
      return state
    // throw new Error(`No case type ${type} found`)
  }
}

export default reducer
